@if (usersAndAdGroups.length > 0) {
  <div class="wre-table-container w-100">
    <div #tableContainer class="table-responsive">
      <table class="table wre-table fixed-column table-hover p-0 m-0">
        <thead class="text-center px-0 pt-2 m-0 d-block">
          <tr class="t-header">
            <th class="text-nowrap col-ellipsis column-active"></th>
            <th class="text-nowrap col-ellipsis column-users">Name</th>
            <th class="text-nowrap col-ellipsis column-adgroups">Type</th>
            <th class="text-nowrap col-ellipsis column-email">Email Address/Id</th>
            <th class="text-nowrap col-ellipsis column-domain">Domain</th>
            @if (!reviewStep) {
              <th class="text-nowrap col-ellipsis column-active"></th>
            }
          </tr>
        </thead>
        <tbody class="p-0 m-0 table-height">
          @for (item of usersAndAdGroups; track item; let isLast = $last) {
            <tr class="tr-padding" [ngClass]="{ 'border-bottom': isLast }">
              <td class="text-nowrap col-ellipsis column-active">
                <i
                  class="far"
                  [ngClass]="
                    item.type === UserType.adGroup
                      ? 'fa-users'
                      : item.type === UserType.servicePrinciple
                        ? 'fa-desktop'
                        : 'fa-user'
                  "></i>
              </td>
              <td class="text-nowrap col-ellipsis column-users">
                @if (item.displayName && item.displayName.trim() === ',') {
                  <span class="ps-3">&#x2015;</span>
                }
                @if (item.displayName && item.displayName.trim() !== ',') {
                  <span>{{ item.displayName }}</span>
                }
              </td>
              <td class="text-nowrap col-ellipsis column-adgroups">
                {{
                  item.type === UserType.adGroup
                    ? UserType.adGroup
                    : item.type === UserType.servicePrinciple
                      ? UserType.servicePrinciple
                      : 'User'
                }}
              </td>
              <td class="text-nowrap col-ellipsis column-email">
                @if (item.type !== UserType.adGroup) {
                  <span>{{ item.mail }}</span>
                }
                @if (item.type === UserType.adGroup) {
                  <span>&#x2015;</span>
                }
              </td>
              <td class="text-nowrap col-ellipsis column-domain">
                @if (item.type === UserType.internalUser || item.type === UserType.adGroup) {
                  <span class="badge bg-warning me-1">INT</span>
                }
                @if (item.type === UserType.externalUser) {
                  <span class="badge bg-secondary">EXT</span>
                }
                @if (item.type === UserType.servicePrinciple) {
                  <span>&#x2015;</span>
                }
              </td>
              @if (!reviewStep) {
                <td class="text-nowrap col-ellipsis column-delete">
                  <button class="btn-icon btn" role="button" type="button">
                    <i
                      class="fas fa-trash-alt"
                      [ngClass]="{ 'action-not-allowed': !hasMemberPermissions }"
                      (click)="remove(item)"></i>
                  </button>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
} @else {
  <div class="no-users-text px-3 py-3">No users have been selected.</div>
}
